import { createSlice } from '@reduxjs/toolkit';

export const passwordPages = ['sign-in', 'sign-up'];

export const defaultState = {
  model: {
    password: null,
    email: null,
    otp: null
  },
  feedback: {
    isLoading: false,
    success: false,
    message: '',
    action: ''
  },
};

const authSlice = createSlice({
  initialState: defaultState,
  name: 'auth',
  reducers: {
    updateFeedback: (state, { payload }) => {
      if (!payload) {
        state.feedback = defaultState.feedback;
      } else {
        state.feedback = {
          ...state.feedback,
          ...payload
        };
      }
    },
    updateModel: (state, { payload }) => {
      state.model = {
        ...state.model,
        ...payload
      };
    }
  }
});

export const {
  updateFeedback,
  updateModel
} = authSlice.actions;

export default authSlice.reducer;